import { StackLayout } from '@euler/app/components/StackLayout';
import { Typography } from '@euler/app/components/typography';
import { StatusColors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import { HStack } from '@euler/components/layout/Stack';
import { PredefinedHitSlops } from '@euler/functions/predefinedHitSlops';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import {
  StyleProp,
  TextStyle,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';

export const QuotationCatalogSubjectCell = memo(
  ({
    title,
    selected,
    checked,
    deletable,
    checkable,
    style,
    titleStyle,
    onPress,
    onRemove,
    onAdd,
    onDelete,
  }: {
    title: string;
    selected?: boolean;
    checked?: boolean;
    deletable?: boolean;
    checkable?: boolean;
    style?: StyleProp<ViewStyle>;
    titleStyle?: StyleProp<TextStyle>;
    onPress?: () => void;
    onRemove?: () => void;
    onAdd?: () => void;
    onDelete?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        css={`
          min-height: ${rpx(44)}px;
          border-radius: ${rpx(22)}px;
          padding-left: ${rpx(15)}px;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        `}
        style={style}
        onPress={onPress}
      >
        <StackLayout
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          css={`
            flex: 1;
          `}
        >
          {checkable ? (
            <Icon
              name={checked ? 'checkbox' : 'checkbox_outline'}
              color={checked ? 'rgba(32, 127, 231, 1)' : '#777'}
              size={rpx(20)}
              css={`
                margin-right: ${rpx(5)}px;
                transform: translateY(${rpx(-0)}px);
              `}
            />
          ) : null}
          <HStack
            justifyContent="flex-start"
            alignItems="center"
            css={`
              flex: 1;
            `}
          >
            {deletable ? (
              <TouchableOpacity
                onPress={onDelete}
                css={`
                  height: ${rpx(44)}px;
                  width: ${rpx(20)}px;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  flex-grow: 0;
                  margin-right: ${rpx(4)}px;
                `}
                hitSlop={PredefinedHitSlops.large}
              >
                <Icon name="closecircle" color={'#ccc'} size={rpx(18)} />
              </TouchableOpacity>
            ) : null}
            <Typography.Label
              medium
              size={rpx(15)}
              numberOfLines={1}
              style={titleStyle}
            >
              {title}
            </Typography.Label>
          </HStack>
          <TouchableOpacity
            onPress={selected ? onRemove : onAdd}
            css={`
              height: ${rpx(44)}px;
              width: ${rpx(50)}px;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              flex-grow: 0;
            `}
            hitSlop={PredefinedHitSlops.large}
          >
            <Icon
              name={selected ? 'minus-circle' : 'plus-circle'}
              color={selected ? StatusColors.Danger : StatusColors.Info}
              size={rpx(24)}
            />
          </TouchableOpacity>
        </StackLayout>
      </TouchableOpacity>
    );
  },
);
